import {
  Component,
  OnInit,
  ViewEncapsulation,
  Input,
  ViewChild,
  ViewContainerRef,
} from "@angular/core";
import { Color } from "ng2-charts";

import { ZoneComponent } from "@/shared-module/components";
import { WaterfallChartDatasource } from "@/shared-module/models";
import { DialogService } from "@/shared-module/services";

@Component({
  selector: "app-waterfall",
  templateUrl: "waterfall.component.html",
  encapsulation: ViewEncapsulation.None,
})
export class WaterfallComponent implements ZoneComponent, OnInit {
  @Input() data: WaterfallChartDatasource;
  @Input() width: number;
  @Input() needpaddingLeft: boolean;
  @Input() isZoom: boolean;
  @ViewChild("template", { static: true }) template;

  constructor(
    private viewContainerRef: ViewContainerRef,
    private dialogService: DialogService,
  ) {}

  public lineChartColors: Color[] = [
    {
      // grey
      backgroundColor: "transparent",
      borderColor: "transparent",
      pointBackgroundColor: "transparent",
      pointBorderColor: "transparent",
      pointHoverBackgroundColor: "transparent",
      pointHoverBorderColor: "transparent",
    },
  ];
  public barChartData: any[] = [];
  public barChartLabels: string[] = [];
  public barChartType = "bar";

  public barChartOptions: any = {
    aspectRatio: 1.5,
    responsive: true,
    tooltips: {
      filter(tooltipItem, data) {
        if (tooltipItem.datasetIndex === 0) {
          return false;
        } else {
          return true;
        }
      },
      callbacks: {
        title: (items, data) => {
          if (items.length === 0) {
            return null;
          }
          return this.data.xLabels[items[0].index];
        },
        label: (tooltipItem, data) => {
          const label = this.data.series[tooltipItem.index].yValues[0].yLabel;
          return label;
        },
      },
    },
    legend: {
      display: false,
    },
    scales: {
      xAxes: [
        {
          stacked: true,
          id: "x-axis-0",
          offset: true,
          gridLines: {
            drawBorder: false,
            zeroLineColor: "transparent",
            display: false,
          },
        },
      ],
      yAxes: [
        {
          stacked: true,
          id: "y-axis-0",
          gridLines: {
            drawBorder: true,
            borderDash: [2, 5],
            display: true,
          },
          ticks: {
            beginAtZero: true,
            callback: (value: number) => {
              if (this.data.axisY.unit)
                return value + " " + this.data.axisY.unit;
              return value;
            },
          }
        },
      ],
    },
  };

  ngOnInit() {
    this.viewContainerRef.createEmbeddedView(this.template);

    if (this.data) {
      this.barChartData = [];
      this.barChartLabels = [];

      const dataPos = [];
      const dataNeg = [];
      const dataInv = [];

      this.data.xLabels.forEach((v) => {
        this.barChartLabels.push(v);
      });
      const backgroundColor = [];
      this.data.series.forEach((s) => {
        backgroundColor.push(s.color);
      });

      let invisibleBar = 0;
      const nbSeries = this.data.xLabels.length;
      let seriesIdx = 0;

      // invisible bar
      this.data.series.forEach((s) => {
        const v = s.yValues[0].y;

        if (seriesIdx === 0 || seriesIdx === nbSeries - 1) {
          invisibleBar = 0;
        }

        let min = invisibleBar;
        let max = invisibleBar + v;

        if (v < 0) {
          min = invisibleBar + v;
          max = invisibleBar;
        }

        if (min >= 0 && max >= 0) {
          dataInv.push(min);
          dataPos.push(Math.abs(v));
          dataNeg.push(0);
        } else if (min < 0 && max <= 0) {
          dataInv.push(max);
          dataPos.push(0);
          dataNeg.push(-Math.abs(v));
        } else {
          dataInv.push(0);
          dataPos.push(Math.abs(max));
          dataNeg.push(min);
        }
        invisibleBar += v;

        seriesIdx++;
      });

      let barThickness = 15;
      if (this.data.zoomInfo == null) barThickness = 30;

      // tslint:disable-next-line:object-literal-shorthand
      const dsInv = {
        data: dataInv,
        label: "invisible",
        barThickness: barThickness,
      };
      // tslint:disable-next-line:object-literal-shorthand
      const dsPos = {
        data: dataPos,
        label: "waterall",
        barThickness: barThickness,
        backgroundColor: backgroundColor,
      };
      // tslint:disable-next-line:object-literal-shorthand
      const dsNeg = {
        data: dataNeg,
        label: "waterall(neg)",
        barThickness: barThickness,
        backgroundColor: backgroundColor,
      };

      this.barChartData.push(dsInv);
      this.barChartData.push(dsPos);
      this.barChartData.push(dsNeg);
    }
  }

  zoom() {
    this.dialogService.setZoomInfo(this.data.zoomInfo);
  }
  secondZoom() {
    this.dialogService.setZoomInfo(this.data.secondZoomInfo);
  }
  getSecondZoomCaption()
  {
    if(this.data.secondZoomInfo)
    {
      return this.data.secondZoomInfo["secondZoomCaption"];
    }
  }
}
